import type { OrgProfile } from '@appTypes/esb';
import { organizationTypeId as orgTypeId } from '@shared/constants';
import removeLeadingZeros from '@utils/removeLeadingZeros';

import type { NormalizedOrgProfile } from '../types';

export function transformOrgProfile(
  unitInfo: OrgProfile,
): NormalizedOrgProfile {
  if (!unitInfo) return unitInfo;

  const {
    number,
    name,
    organizationFullName,
    organizationTypeId,
    organizationGuid,
  } = unitInfo;
  const formattedNumber = removeLeadingZeros(number);
  const formattedName = removeLeadingZeros(name);
  const formattedOrganizationFullName = organizationFullName.replace(
    name,
    formattedName,
  );

  const isDistrict = organizationTypeId === orgTypeId.COUNCIL_ENTITY;

  return {
    ...unitInfo,
    number: formattedNumber,
    name: formattedName,
    organizationFullName: formattedOrganizationFullName,
    ...(isDistrict && {
      districtGuid: organizationGuid,
      districtName: formattedName,
      districtNumber: formattedNumber,
    }),
  };
}
